<template>
  <section class="row custom-wall">
    <div v-if="isMultiple" class="row">
      <div class="col-md-12">
        <auto-suggest
          v-model="selectedMembers"
          placeholder="add a client (type to search)"
          :minChars="2"
          :delay="750"
          :searchable="true"
          :options="searchHandler"
          :object="true"
          :filterResults="false"
          :resolveOnLoad="false"
          mode="tags"
          @clear="validateMessage"
          @select="validateMessage"
        />
      </div>
    </div>
    <div class="row" :class="{ 'custom-multiple': isMultiple }">
      <div v-if="!isMultiple" class="col-md-3">
        <wall-messages
          :to="to"
          @beforeView="beforeView"
          @view="viewMessage"
          @refresh="refreshMessages(false)"
        />
      </div>
      <div class="col-md-9" :class="{ 'col-md-12': isMultiple }">
        <email-message
          :view="to"
          :msgId="msgId"
          ref="emailMessage"
          @edited="edited"
          @setNew="setNew"
          @valid="valid"
          @show="showFile"
        />
        <!-- <wall-message
          ref="wallMessage"
          :to="to"
          :view="msgId"
          @setNew="setNew"
          @valid="valid"
          @sending="sending"
          @sent="refreshMessages(true)"
        /> -->
      </div>
    </div>
    <coaching-image-dialog
      id="coaching-image-modal"
      :show="actionImage"
      @close="closeModal"
    />
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import AutoSuggest from '@vueform/multiselect'
import WallMessage from '@/Components/Coaching/wall-message'
import WallMessages from '@/Components/Coaching/wall-messages'
import EmailMessage from '@/Components/UserCardio/elements/email-message'
import CoachingImageDialog from '@/Components/Coaching/coaching-image-dialog'
export default {
  name: 'coaching-wall',
  components: {
    AutoSuggest,
    WallMessage,
    WallMessages,
    EmailMessage,
    CoachingImageDialog,
  },
  props: {
    to: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      msgId: null,
      actionImage: null,
    }
  },
  emits: ['viewing', 'edited', 'valid', 'sending'],
  computed: {
    ...mapGetters('users', ['profile']),
    ...mapGetters('organizations', ['examineOrganization']),
    isMultiple() {
      let _data = false
      if (this.to !== undefined && this.to !== null) {
        if (this.to.id === undefined || this.to.id === null) {
          _data = true
        }
      }
      return _data
    },
    selectedMembers: {
      get() {
        let _data = []
        if (this.to.memberids !== undefined && this.to.memberids !== null) {
          this.to.memberids.forEach((element) => {
            let name = `${element.FirstName} ${element.LastName}`
            _data.push({
              id: element.user_id,
              value: name,
              label: name,
            })
          })
        }
        return _data
      },
      set(value) {
        this.setRecipients({
          source: 1,
          recipients: value,
        })
      },
    },
  },
  methods: {
    ...mapActions('users', ['findUsers']),
    ...mapActions('coaching', ['getWallMessages']),
    ...mapActions('messages', ['setRecipients', 'saveMessage']),
    closeModal() {
      this.actionImage = null
    },
    async searchHandler(query) {
      let options = {
        term: query,
        orgId: this.examineOrganization.id,
      }
      // console.log('Searching for Members', options)
      return await this.findUsers(options)
    },
    async refreshMessages(reset) {
      this.valid(false)
      // this.$refs.wallMessage.setNew()
      if (this.to.id !== null) {
        let data = {
          id: this.to.id,
          orgId: this.examineOrganization.id,
          reset: reset,
        }
        await this.getWallMessages(data)
      }
    },
    setNew() {
      this.msgId = null
      this.$emit('viewing', false)
    },
    edited(value) {
      this.$emit('edited', value)
    },
    validateMessage() {
      this.notice = ''
      let valid = true
      let whatsNot = ''
      if (this.subject.trim() === '') {
        valid = false
        whatsNot = 'subject'
      }
      if (valid && !this.isEmail && !this.isNotification) {
        valid = false
        whatsNot = 'send as'
      }
      let body = this.messageBody()
      if (valid && body.trim() === '') {
        valid = false
        whatsNot = 'body'
      }
      if (valid && this.recipients.length === 0) {
        valid = false
        whatsNot = 'recipients'
      }
      this.$emit('valid', valid)
    },
    beforeView() {
      this.$refs.emailMessage.setNew()
    },
    viewMessage(msg) {
      this.msgId = parseInt(msg.id)
      this.$refs.emailMessage.setWallMessage()
    },
    valid(data) {
      this.$emit('valid', data.isValid)
    },
    showFile(file) {
      this.actionImage = null
      console.log('Showing File', file)
      if (file.name.indexOf('.') >= 0) {
        let elements = file.name.split('.')
        let showImage = true
        if (elements.length > 0) {
          let ext = elements[elements.length - 1].toLowerCase()
          if (ext === 'pdf' || ext === 'doc' || ext === 'xls') {
            showImage = false
          }
        }
        if (showImage) {
          this.actionImage = file
        } else {
          window.open(file.url, '_blank')
        }
      }
    },
    sending(is) {
      this.$emit('sending', is)
    },
    async send() {
      // this.$refs.wallMessage.send()
      this.$emit('sending', true)
      let data = await this.$refs.emailMessage.getMessageData()
      if (data) {
        console.log('Coach Wall - Sending Message', data)
        let results = await this.saveMessage(data)
        console.log('Message Sent', results)
        this.$emit('sending', false)
        if (results !== 'Success') {
          alert(`Message Failed: ${results}`)
        } else {
          if (data.email === 'on') {
            alert('Message Sent')
          }
          this.refreshMessages(true)
          this.$refs.emailMessage.setNew()
          this.setNew()
        }
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-wall {
  height: 550px;
  position: relative;
}
.custom-multiple {
  position: relative;
  top: -30px;
}
</style>
